// extracted by mini-css-extract-plugin
export default {"logo":"Rea","cancel":"Sea","stickyheader":"Tea","buttonswrap":"Uea","item":"Vea","starterKit":"Wea","boldHeader":"Xea","reviewheader":"Yea","text":"Zea","username":"afa"};
    if(module.hot) {
      // 1738836199203
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  